<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :inputs="totalInputs"
    :finished="touchedInputs"
  >
    <p><i class="fa fa-info-circle"/> toucanBox is a regular delivery of craft boxes.
    You can change or stop your deliveries at any time,
    and you’ll only ever pay on a box-by-box basis.</p>

    <br>

    <div class="modify-header">
      <h5>Your details</h5>
      <a @click="modify('account')">Modify</a>
    </div>
    <p><strong>Name:</strong> Customer name<br>
    <strong>Email:</strong> Customer email</p>

    <br>

    <div class="modify-header">
      <h5>Your address</h5>
      <a @click="modify('address')">Modify</a>
    </div>
    <p>Address line 1
      <br>Address line 2
      <br>Postcode
    <br>City</p>
    <br>

    <div class="modify-header">
      <h5>Your order</h5>
      <a @click="modify('children')">Modify</a>
    </div>
    <div class="inline-order">
      <Order
        :title="'Order summary'"
        :products="names.length"
        :names="names"
        :discount="discount"
      />
    </div>

    <button
      class="success cta continue-button"
      @click="next">Place order</button>

    <p class="hint">(we'll send you a confirmation email too)</p>
  </Page>
</template>

<script>
import Page from '../library/page.vue'
import Order from '../library/order-table.vue'

export default {
  name: 'Account',
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    },
    names: {
      type: Array,
      default: function () { return [] }
    },
    discount: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Page,
    Order
  },
  data () {
    return {
      title: 'Almost there!',
      message: 'Please review your details and submit your order.',
      totalInputs: 1,
      touchedInputs: 0
    }
  },
  methods: {
    next: function (event) {
      this.incrementInput()
      this.$events.$emit('load-advance', true)
      this.$emit('update-signup-object')
    },
    incrementInput: function (event) {
      this.touchedInputs++
    },
    modify: function (route) {
      this.$events.$emit('review-modify', route)
    }
  }
}
</script>

<style lang="scss" scoped>
 p.hint {
   text-align: center;
 }
</style>



// WEBPACK FOOTER //
// src/components/pages/review.vue